import { render, staticRenderFns } from "./spectaculars.vue?vue&type=template&id=112a260b&scoped=true&"
import script from "./spectaculars.vue?vue&type=script&lang=js&"
export * from "./spectaculars.vue?vue&type=script&lang=js&"
import style0 from "./spectaculars.vue?vue&type=style&index=0&id=112a260b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a260b",
  null
  
)

export default component.exports